export default __webpack_public_path__ + "static/media/lg-e.c4f29962.jpg";